/* receipt/sagas*/
import { all, put, takeEvery, spawn, takeLatest } from "redux-saga/effects";
import { isEmpty } from "ramda";
import { ReceiptActionTypes } from "./types";
import { fetch, drop, save } from "../../repo/receipt";
import {
  fetchRequest,
  fetchError,
  fetchSuccess,
  deleteError,
  deleteRequest,
  deleteSuccess,
  saveError,
  saveRequest,
  saveSuccess,
} from "./actions";
import { dirty } from "../session/actions";
import { isAuthError } from "../";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const receipt = yield fetch(action.payload.id, action.payload.params);
    if (receipt.errors && !isEmpty(receipt.errors)) {
      if (isAuthError(receipt.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(receipt.errors)));
    } else {
      yield put(fetchSuccess(receipt));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(ReceiptActionTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const data = yield save(action.payload.data);
    // we may still have an error
    // if so then we should yield error
    if (data.errors && !isEmpty(data.errors)) {
      if (isAuthError(data.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(data.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(data.errors), null);
    } else {
      yield put(saveSuccess(data));
      action.payload.callback && action.payload.callback(null, data);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
      action.payload.callback("An error occurred while saving POS", null);
  }
}

function* watchSaveRequest() {
  yield takeEvery(ReceiptActionTypes.SAVE_REQUEST, handleSave);
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const dropResponse = yield drop(action.payload.id);

    if (dropResponse.errors && !isEmpty(dropResponse.errors)) {
      if (isAuthError(dropResponse.errors)) {
        yield put(dirty());
      }
      yield put(deleteError(JSON.stringify(dropResponse.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(dropResponse.errors));
    } else {
      yield put(deleteSuccess());
      action.payload.callback && action.payload.callback(null);
      yield put(fetchRequest(null));
    }
  } catch (err) {
    yield put(deleteError(err));
    action.payload.callback && action.payload.callback(JSON.stringify(err));
  }
}

function* watchDeleteRequest() {
  yield takeLatest(ReceiptActionTypes.DELETE_REQUEST, handleDelete);
}

export default function* posSaga() {
  yield all([
    spawn(watchFetchRequest),
    spawn(watchSaveRequest),
    spawn(watchDeleteRequest),
  ]);
}
